'use client';

import React from 'react';
import { TypographyH2, TypographyP } from '@/components/ui/typography';
import SectionBase from '@/components/ui/sections/section-base';

export const SECTION_ID = 'decision-making';

export default function DecisionMakingSection() {
  return (
    <SectionBase id={SECTION_ID} background="bg-card">
      <TypographyH2>Empowering Your Decision-Making Process</TypographyH2>

      <TypographyP>
        Our aim is to leave you feeling informed and empowered, armed with all
        the information you need to make the right decision for your home
        project.
      </TypographyP>

      <TypographyP>
        Remember, the decision is yours to make. We&apos;re here to guide and
        support you every step of the way.
      </TypographyP>

      <TypographyP>
        Choosing the Cornerstone Homes team means choosing value and
        confidence in your project. Let&apos;s create something exceptional
        together!
      </TypographyP>
    </SectionBase>
  );
}
